import {
  AxiosMethod,
  defaultAxiosOptions,
  serviceEndpoints,
} from '../../constants';
import { IPlainObject, OfferGeoModel } from '../../models';
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import useAxios from 'axios-hooks';
import { ResponseValuesOverride } from '../../models/response-values-override';

export function useSaveOfferGeo<T = IPlainObject>(
  offerGeoId?: string,
): [
  ResponseValuesOverride<OfferGeoModel>,
  (data: T, config?: AxiosRequestConfig) => AxiosPromise<OfferGeoModel>,
] {
  const config: AxiosRequestConfig = {
    method: offerGeoId ? AxiosMethod.Put : AxiosMethod.Post,
    url: serviceEndpoints.offerGeoApi(offerGeoId),
  };

  const [responseData, execute] = useAxios<OfferGeoModel>(config, {
    ...defaultAxiosOptions,
  });

  return [
    responseData,
    (data: T, config?: AxiosRequestConfig): AxiosPromise<OfferGeoModel> =>
      execute({
        ...config,
        data,
      }),
  ];
}
